import { IRejectProvenances } from '../../../actions/provenances/loadProvenances'
import { IProvenancesStore } from '../index'

export default function(
  store: IProvenancesStore,
  action: IRejectProvenances,
): IProvenancesStore {
  return {
    ...store,
    request: {
      ...store.request,
      errMessage: action.errMessage,
      isLoading: false,
    },
  }
}
